import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";

import { endpoint } from "@services/api.services";
import { QueryData } from "@utils/interface/index.interface";
import { MomentsData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import MomentsForm from "./form/moments.form";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { useEffect } from "react";
const index = () => {
  const pathname = usePathname();
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<
    QueryData<MomentsData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
    },
    endpoint: endpoint["moments"],
    key: `${pathname}-listing`,

    // window: true,
    // enabled: !["drag"].includes(searchParams.get("orientation")||"")
  });
  // rollback page
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);
  const columns = ColumnList();
  return (<>
    <TableCard
      bulkActions
      table_content={{
        mode: "default",
        type: pathname,
      }}
      inject_ui_table_actions
      sortableFilter={{
        search: search,
        ordering: searchParams.get("ordering") || "order",
      }}
      showOrientation
      grid={
        <GeneralCard
          type={"moments"}
          showCheck
          className={
            "border group border-[#E8F6F1] rounded-[20px] overflow-hidden w-full min-w-[273px]"
          }
          onDelete={() => {}}
          onEdit={() => {}}
        />
      }
      form={<MomentsForm />}
      refetch={refetch}
      endpoint={endpoint["moments"]}
      columns={columns}
      isPending={isPending}
      rows={data?.data?.results ?? []}
      count={data?.data?.count ?? 10}
    />
  </>);
};

export default index;
